export default function externalLinks () {
  const links = document.querySelectorAll('a[rel="external"]')
  for (let i = 0; i < links.length; i++) {
    (function () {
      const link = links[i]
      link.addEventListener('click', function (ev) {
        ev.preventDefault()
        window.open(link.href)
      })
    })()
  }
}
